module.exports = __webpack_public_path__ + "a905da48df22be665a3767967a8a5927.pdf";